import React, { useEffect, useState } from "react";
import { Card, Col, Input, Row } from "antd";
import "../../index.css";

const WidgetName = ({ widget, handleWidgetChange }) => {
  const [name, setName] = useState();
  const handleSaveName = () => {
    handleWidgetChange({ name, id: widget.id });
  };

  useEffect(() => {
    setName(widget.name);
  }, [widget]);

  return (
    <Card className="setting_wrapper">
      <div className="setting_title">
        <h4 className="p-color">Widget Name</h4>

        <div onClick={handleSaveName} className="action_btn">
          <i className="fa-regular fa-floppy-disk"></i>
          <span>Save</span>
        </div>
      </div>
      <Row>
        <Col span={24}>
          <div className="setting_field">
            <Input
              placeholder="Widget Name"
              onChange={(e) => {
                setName(e.target.value);
              }}
              name="name"
              value={name}
            />
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default React.memo(WidgetName);
